<template>
	<div class="login">
		<div class="login__form">
			<img class="login__logo" src="@/assets/logo.svg" alt="recycle race" />
			<LoginForm />
		</div>
	</div>
</template>

<script>
import LoginForm from '@/components/LoginForm'

export default {
	name: 'Login',
	components: {
		LoginForm,
	},
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';
@import '~scss/layout';

.login {
	@extend %flex-center;
	height: 100%;
	background-color: $grey-95;

	&__logo {
		width: 100%;
		display: block;
		margin-bottom: 2rem;
	}

	&__form {
		background-color: $white;
		padding: 2rem;
	}
}
</style>
